<template>
  <component
    :is="componentType"
    :class="classList"
    @click="click"
    :disabled="buttonDisabled"
    v-bind="dynamicAttrs"
  >
    {{ buttonOptions.label }}
  </component>
</template>

<script>
  import { openUrl } from 'Services/LinkService'
  import { buildClassString } from 'Utils'

  export default {
    computed: {
      buttonDisabled () {
        return this.buttonOptions.disabled === undefined ? false : this.buttonOptions.disabled
      },
      componentType () {
        if (this.buttonOptions.href) {
          return 'a'
        } else {
          return 'button'
        }
      },
      classList () {
        return buildClassString('card-button', [
          {
            className: 'disabled',
            testCondition: () => this.buttonDisabled,
            bem: true,
          },
          {
            className: 'no-underline',
            testCondition: true,
          },
          {
            className: 'tw:first:rounded-bl-md',
            testCondition: true,
          },
          {
            className: 'tw:last:rounded-br-md',
            testCondition: true,
          },
        ])
      },
      dynamicAttrs () {
        const attrs = {}

        if (this.buttonOptions.href) {
          attrs.href = this.buttonOptions.href
        }

        return attrs
      },
    },
    methods: {
      click () {
        if (this.buttonDisabled) {
          return
        }

        if (this.buttonOptions.key !== undefined && this.buttonOptions.key !== null) {
          this.$emit('click', this.buttonOptions.key)
        }

        if (this.buttonOptions.url !== undefined && this.buttonOptions.url !== null) {
          openUrl(this.buttonOptions.url, this.buttonOptions.newTab)
        }
      },
    },
    props: {
      buttonOptions: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
@use "~Styles/colors";
@use "~Styles/mixins";
@use "~Styles/variables";

  .card-button {
    @include mixins.transition-bg-hover(colors.$kommander-hover-row-bg);
    @include mixins.clickable();
    @include mixins.no-select();

    align-items: center;
    background-color: transparent;
    border: none;
    color: colors.$kommander-blue;
    display: flex;
    flex: 1;
    font-weight: variables.$button-font-weight;
    justify-content: center;
    padding: variables.$button-vertical-padding-mobile 0;
    text-transform: variables.$button-text-transform;

    &--disabled {
      @include mixins.transition-bg-hover(colors.$kommander-hover-disabled-row-background);
      @include mixins.clickable(not-allowed);

      color: colors.$kommander-dark-font-color-2;
    }
  }
</style>
